import { Component, ViewChild, TemplateRef, Input, OnInit, OnDestroy } from "@angular/core";
import { BsModalService } from "ngx-bootstrap/modal";
import { BsModalRef } from "ngx-bootstrap/modal";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { AuditHistoryService } from "../../services/audithistory.service";
import { IAuditHistory } from "../../interfaces/iaudithistory";

@Component({
    selector: "history-modal",
    templateUrl: "./historymodal.component.html",
    standalone: false
})
export class HistoryModalComponent implements OnInit, OnDestroy {
    @Input() title!: string;
    @Input() itemConfigId!: number;
    @Input() countryCode!: string;

    showLoading: boolean = true;
    public auditHistory!: IAuditHistory[];
    private destroy$ = new Subject<void>();

    constructor(private modalService: BsModalService, private auditHistoryService: AuditHistoryService) { }

    @ViewChild("history") historyModal!: TemplateRef<any>;
    modalInstance!: BsModalRef;

    /*
     * Initializes the modal
     */
    // tslint:disable-next-line:no-empty
    ngOnInit(): void {
    }

    open(): void {
        this.showLoading = true;
        this.auditHistoryService.getHistory(this.itemConfigId, this.countryCode)
            .pipe(takeUntil(this.destroy$))
            .subscribe(res => {
                this.showLoading = false;
                this.auditHistory = res;                
            });
        this.modalInstance = this.modalService.show(this.historyModal, { "class": "modal-lg" });
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}

